/* oxlint-disable no-console -- Wrapper around 'console.log' like calls */
import * as Sentry from "@sentry/solid";
import type { CaptureContext } from "@sentry/core";
import { isNil } from "lodash-es";
import { LOG_COLLECTOR_URL } from "../constants";

const logger = {
  log: console.log,
  error: (message: string, error?: unknown, captureContext?: CaptureContext): void => {
    console.error(message, error);

    if (isNil(error)) {
      Sentry.captureMessage(message, captureContext);
    } else {
      Sentry.captureException(new Error(message, { cause: error }), captureContext);
    }
  },
  debug: console.debug,
  warn: console.warn,
  sendToLogCollector: (message: string, data: Record<string, unknown>) => {
    const body = {
      severity: "INFO",
      source: "platform",
      message,
      data,
    };

    logger.log(message, data); // Also log in the browser, so it is added to the Sentry context
    fetch(`${LOG_COLLECTOR_URL}/log`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => {
        if (!res.ok) {
          logger.error(`Log collector responded with status ${res.status}`);
        }
      })
      .catch((err) => {
        // Only network failures (offline, blocked by extensions or proxies) end up here, not actionable for us
        logger.warn("Failed to send log to log collector", err);
      });
  },
};

export default logger;
